import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import KeenSlider from 'keen-slider'
import { initSliderWrapper, initArrows } from '@/lib/keen-slider.js'

export default component((node,ctx) => {
  /*******************************************************************************************************************************************/
  /* Data + elements
  /*******************************************************************************************************************************************/
  const { sliderWrapper, sliderEl, prev, next } = zelektor(node)


  /*******************************************************************************************************************************************/
  /* Init
  /*******************************************************************************************************************************************/
  const slider = new KeenSlider(sliderEl, {
    slidesPerView: 4.25,
    loop: true,
    centered: true,
    spacing: 15,
    duration: 1000,
    breakpoints: {
      '(max-width: 1024px)': {
        slidesPerView: 3.25
      },
      '(max-width: 768px)': {
        slidesPerView: 2.25
      },
      '(max-width: 512px)': {
        slidesPerView: 1.25
      }
    },
    dragStart: () => stopInterval(),
    created: slider => {
      initSliderWrapper(sliderWrapper)
      initArrows(slider, prev, next)
    }
  })
})